import { motion } from 'framer-motion';
import { loginSlideInLeft } from '@/lib/animations';

const AUTH_BG_IMAGE = "https://storage.googleapis.com/hobbes-assets/HobbesPlatform_BackgroundImage.png";
const WHITE_LOGO = "https://storage.googleapis.com/hobbes-assets/FullLogo2026.svg";

export function AuthRightPanel() {
  return (
    <motion.div
      variants={loginSlideInLeft}
      initial="initial"
      animate="animate"
      transition={{ delay: 0.4 }}
      className="relative hidden lg:flex items-center justify-center overflow-hidden rounded-xl m-4"
    >
      {/* Background Image */}
      <img
        src={AUTH_BG_IMAGE}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Logo Overlay */}
      <motion.img
        src={WHITE_LOGO}
        alt="Hobbes"
        className="relative z-10 max-w-md w-full h-auto object-contain drop-shadow-2xl"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      />
    </motion.div>
  );
}
